export const OTHER_IMMIGRATION_DOCUMENTS = [
    {
        text: 'ssap.input.label.orr_certification',
        name: 'orrcertificationIndicator'
    },
    {
        text: 'ssap.input.label.orr_eligibility_letter',
        name: 'orreligibilityLetterIndicator'
    },
    {
        text: 'ssap.input.label.cuban_haitian_entrant',
        name: 'cubanHaitianEntrantIndicator'
    },
    {
        text: 'ssap.input.label.american_samoan',
        name: 'americanSamoanIndicator'
    },
    {
        text: 'ssap.input.label.domestic_violence',
        name: 'domesticViolence'
    },
    {
        text: 'ssap.input.label.indian_of_us_or_canada',
        name: 'indianOfUsOrCanada'
    },
    {
        text: 'ssap.input.label.withholding_of_removal',
        name: 'withholdingOfRemovalIndicator'
    },
    {
        text: 'ssap.input.label.none_of_these_other',
        name: 'noneOfTheseOther'
    }
];